import { CommonModule } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { Timesheet } from '../../../interfaces/timesheet.interface';
import { FiltroService } from '../../../service/filtro.service';
import { PaginationComponent } from '../pagination/pagination.component';
import { BehaviorSubject, Subscription, switchMap } from 'rxjs';
import { FiltroCommesse } from '../../../interfaces/filtro-commesse.interface';
import { AppService } from '../../../service/app.service';
import { Utente } from '../../../interfaces/user';
import { CurrentSort } from '../../../interfaces/table.interface';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LoaderService } from '../../../service/loader.service';
import { TimesheetService } from '../../../service/timesheet.service';

@Component({
  selector: 'app-tabella-commesse',
  standalone: true,
  imports: [CommonModule, PaginationComponent, MatTooltipModule],
  templateUrl: './tabella-commesse.component.html',
  styles: ``,
})
export class TabellaCommesseComponent implements OnInit {
  formatoDaMostrare: 'ore' | 'percentuale' = 'percentuale';

  private _timesheets!: Timesheet[];
  @Input() set timesheets(value: Timesheet[]) {
    if (value) {
      this._timesheets = value;
    }
  }

  get timesheets() {
    return this._timesheets;
  }

  @Input() utenteRisorsa: boolean = true;

  @Input() mese: number = 0;

  @Input() anno: number = 0;

  @Input() elencoCount: number = 0;

  private _giorniModificati!: any;
  @Input() set giorniModificati(value: any) {
    if (value) {
      this._giorniModificati = value;
      this.celleModificate();
    }
  }
  get giorniModificati() {
    return this._giorniModificati;
  }

  lunghezzaTimesheet: number = 31;

  mapMesi = [
    'Gennaio',
    'Febbraio',
    'Marzo',
    'Aprile',
    'Maggio',
    'Giugno',
    'Luglio',
    'Agosto',
    'Settembre',
    'Ottobre',
    'Novembre',
    'Dicembre',
  ];

  currentSort: CurrentSort = { orderBy: '', flagAsc: false };
  totalPages: number = 0;
  currentPage: number = 0;
  pageOffset: number = 10;
  form: any = {};
  filtro: FiltroCommesse = {
    risorsa: null,
    matricola: null,
    codiceCommessa: null,
    descrizioneCommessa: null,
    pageNumber: 1,
    pageSize: 10,
    orderBy: '',
    flagAsc: true,
    flagExport: false,
  };
  pageSubscriptions: Subscription = new Subscription();

  indiceGiorniInTrasferta: number[] = [];
  indiceGiorniCoincidenza: number[] = [];
  indiceGiorniModificati: number[] = [];
  commesseModificate: any[] = [];
  commesseCoincidenze: any[] = [];
  commesseTrasferte: any;

  @Output('emitSortAndPage') emitSortAndPage: EventEmitter<FiltroCommesse> =
    new EventEmitter();

  private readonly pageSubject = new BehaviorSubject<number>(0);
  utente: Utente = this.appService.user;

  constructor(
    private timesheetService: TimesheetService,
    private loaderService: LoaderService,
    private filtroService: FiltroService,
    private appService: AppService,
    private cd: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.lunghezzaTimesheet = new Date(this.anno, this.mese, 0).getDate();

    this.commesseTrasferte = this.timesheets.find(
      (t) => t.tipologia === 'TRASFERTA'
    ) ;
    this.commesseCoincidenze = this.timesheets.filter(
      (t) => t.coincidenza === true
    );

    this.celleModificate();

    if (
      !this.utenteRisorsa &&
      this.filtroService.ultimaPaginaCommesseInfo.pageOffset
    ) {
      this.pageOffset = this.filtroService.ultimaPaginaCommesseInfo.pageOffset;
    }
    if (
      !this.utenteRisorsa &&
      this.filtroService.ultimaPaginaCommesseInfo.currentPage
    ) {
      this.currentPage =
        this.filtroService.ultimaPaginaCommesseInfo.currentPage;
    }
    if (!this.utenteRisorsa) {
      this.totalPages = Math.ceil(this.elencoCount / this.pageOffset);
    }
  }

  celleModificate() {
    this.indiceGiorniInTrasferta = [];
    this.indiceGiorniCoincidenza = [];
    this.indiceGiorniModificati = [];
    this.commesseModificate = [];
    if (this.commesseCoincidenze) {
      this.commesseCoincidenze.forEach((commessa: any) => {
        for (let i = 0; i < this.lunghezzaTimesheet; i++) {
          if (commessa[`d${this.getNumeroGiorno(i)}`]) {
            this.indiceGiorniCoincidenza.push(i);
          }
        }
      });
    }

    if (this.commesseTrasferte) {
      for (let i = 0; i < this.lunghezzaTimesheet; i++) {
        if (this.commesseTrasferte[`d${this.getNumeroGiorno(i)}`]) {
          this.indiceGiorniInTrasferta.push(i);
        }
      }
    }
    const commesseModificate: any = this.timesheets.filter(ts =>
      this.giorniModificati.some((gm: any) => gm.commessa && gm.commessa === ts.tipologia)
    );
    this.commesseModificate = commesseModificate.map((cm: Timesheet) => cm.tipologia);
    if (commesseModificate && this.giorniModificati) {
      commesseModificate.forEach((commessa: any) => {
        this.giorniModificati.forEach((gm: any) => {
          if (gm.commessa && gm.commessa === commessa.tipologia) {
            let giorno = Number(gm.data.split('/')[0]);
            if (commessa[`d${this.getNumeroGiorno(giorno - 1)}`]) {
              this.indiceGiorniModificati.push(giorno - 1);
            }
          }
        });
      });
    }
  }

  sort(orderBy: string) {
    if (!this.utenteRisorsa) {
      if (orderBy === this.currentSort.orderBy) {
        this.currentSort.flagAsc = !this.currentSort.flagAsc;
      } else {
        this.currentSort = {
          orderBy,
          flagAsc: true,
        };
      }
      this.getPage();
    }
  }

  getCaretClass(
    orderBy: string,
    flagAsc: boolean
  ):
    | 'bi-caret-up'
    | 'bi-caret-up-fill'
    | 'bi-caret-down'
    | 'bi-caret-down-fill'
    | undefined {
    if (
      orderBy !== this.currentSort.orderBy ||
      (orderBy === this.currentSort.orderBy &&
        flagAsc !== this.currentSort.flagAsc)
    ) {
      return flagAsc ? 'bi-caret-down' : 'bi-caret-up';
    }

    return flagAsc ? 'bi-caret-down-fill' : 'bi-caret-up-fill';
  }

  getNumeroGiorno(idx: number): string {
    return (idx + 1)?.toString().length > 1 ? `${idx + 1}` : `0${idx + 1}`;
  }

  getStringCampoGiorno(element: Timesheet, ngiorno: number): string {
    if (this.formatoDaMostrare === 'ore') {
      if (element.descrizioneCommessa === null) {
        return `d${this.getNumeroGiorno(ngiorno)}`;
      } else {
        return `o${this.getNumeroGiorno(ngiorno)}`;
      }
    }
    return `d${this.getNumeroGiorno(ngiorno)}`;
  }

  getGiornoValue(el: any, ngiorno: number) {
    return el[this.getStringCampoGiorno(el, ngiorno)];
  }

  handleSearchEvent(event: any): void {
    this.form = event;
    this.getPage();
  }

  getPage(page: number = 0): void {
    this.currentPage = page;

    this.filtroService.setUltimaPaginaCommesseInfo({
      currentPage: this.currentPage,
      pageOffset: this.pageOffset,
    });

    const convertEmptyStringsToNull = (obj: any) => {
      Object.keys(obj).forEach((key) => {
        if (obj[key] === '') {
          obj[key] = null;
        }
      });
      return obj;
    };
    const formValues = convertEmptyStringsToNull(this.form);
    this.filtro = {
      risorsa: formValues.risorsa,
      matricola: formValues.matricola,
      codiceCommessa: formValues.codiceCommessa,
      descrizioneCommessa: formValues.descrizioneCommessa,
      flagExport: false,
      pageNumber: page + 1,
      pageSize: this.pageOffset,
      flagAsc: this.currentSort.flagAsc,
      orderBy: this.currentSort.orderBy,
    };
    this.filtroService.setUltimoFiltroCommesse(this.filtro);
    this.loaderService.show();
    this.pageSubscriptions.add(
      this.timesheetService
        .ricercaTimesheetLivelloCommesse(this.filtro)
        .pipe(
          switchMap((data) => {
            this.timesheets = data;
            return this.timesheetService.ricercaTimesheetLivelloCommesseCount(
              this.filtro
            );
          })
        )
        .subscribe({
          next: (data) => {
            this.elencoCount = data;
            this.totalPages = Math.ceil(this.elencoCount / this.pageOffset);
            this.cd.detectChanges();
          },
          complete: () => this.loaderService.hide(),
          error: () => this.loaderService.hide(),
        })
    );
  }

  changerEvent(value: number): void {
    this.pageOffset = value;
    this.totalPages = Math.ceil(this.elencoCount / this.pageOffset);
    this.currentPage = Math.min(this.currentPage, this.totalPages - 1);
    this.getPage(this.currentPage);
    this.pageSubject.next(this.currentPage);
  }

  exportDataToExcel(): void {
    this.loaderService.show();
    this.filtro.flagExport = true;
    this.pageSubscriptions.add(
      this.timesheetService
        .ricercaTimesheetLivelloCommesse(this.filtro)
        .subscribe({
          next: (result) => {
            if (result) {
              const blob = new Blob([result], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
              });
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = 'TimesheetCompleto.xlsx';
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              window.URL.revokeObjectURL(url);
            }
          },
          complete: () => this.loaderService.hide(),
          error: () => this.loaderService.hide(),
        })
    );
  }

  ngOnDestroy(): void {
    this.pageSubscriptions.unsubscribe();
  }
}
